/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_UpdatedInputs */

const en_admin_tickets_status_updated = /** @type {(inputs: Admin_Tickets_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status updated`)
};

/**
* | output |
* | --- |
* | "Status updated" |
*
* @param {Admin_Tickets_Status_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_updated = /** @type {((inputs?: Admin_Tickets_Status_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_status_updated(inputs)
});
export { admin_tickets_status_updated as "admin.tickets.status_updated" }